import { useEffect, useState } from "react";
import axios from "axios";
import bot from '../images/happy.png';
import you from '../images/boy.png';
import LoadingDots from "./LoadingDots";
import ProcessedFoodItems from "./ProcessedFoodItems";

const ProcessedFood = () => {
    const [PfItems, setPfItems] = useState([]);
    const [selectedPfItem, setSelectedPfItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [time] = useState(new Date());

    useEffect(() => {
        axios
          .get("https://poultry-chatbot-api.onrender.com/processed_foods")
          .then((response) => {
            if (response.data.foods?.length > 0) {
              setPfItems(response.data.foods);
            } else {
              alert("No Data found.");
            }
            setLoading(false); // Set loading to false after data is fetched
          })
          .catch((error) => {
            console.error("Error fetching categories:", error);
            alert("Failed to fetch categories.");
            setLoading(false); // Ensure loading stops in case of error
          });
      }, []); // Empty dependency array means this effect runs once after the first render

    return (
        <>
            <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time.toLocaleTimeString()}
            </div>
            
            <div className="you-message">
                <div className="frame2 animated-frame">Processed Food</div>
            </div>

            {loading ? (
                <div className='frame1 animated-frame'>
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className='chatbot'>
                        <img src={bot} alt="bot" className="bot" />
                        <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>

                    <div className="frame1 animated-frame">
                        Please choose from the following options:
                        <div className="button-container" style={{textAlign: 'center'}}>
                            {PfItems.map((category) => (
                                <button
                                    key={category.pf_id}
                                    className="Menubtns"
                                    onClick={() => setSelectedPfItem(category.pf_id)}
                                >
                                    {category.pf_name}
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}

            {selectedPfItem && <ProcessedFoodItems categoryId={selectedPfItem} />}
        </>
    );
};

export default ProcessedFood;
